class UrlBuilder {
    constructor(baseUrl) {
      this.baseUrl = baseUrl;
    }
  
    buildUrl(endpoint) {
      return `${this.baseUrl}${endpoint}`;
    }
  
    buildUrlWithParams(endpoint, params) {
      const url = `${this.baseUrl}${endpoint}`;
      const queryParams = new URLSearchParams(params);
      return `${url}?${queryParams.toString()}`;
    }
  }
  
  export default UrlBuilder;